import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Dr. Emily Carter',
      role: 'Cardiologist, Boston Medical',
      rating: 5,
      text: 'Lloyd Pharmaceutical provides excellent service and quality medication. My patients are very satisfied with their delivery service.',
      avatar: 'EC' // Initials for avatar
    },
    {
      id: 2,
      name: 'Michael Robinson',
      role: 'Regular Customer',
      rating: 5,
      text: 'Excellent service, fast delivery, and high quality products. Lloyd Pharmaceutical Center never disappoints.',
      avatar: 'MR'
    },
    {
      id: 3,
      name: 'Sarah Thompson',
      role: 'Pharmacist, NYC',
      rating: 5,
      text: 'Lloyd Pharmaceutical Center offers reliable service and authentic medications. I highly recommend them for all your needs.',
      avatar: 'ST'
    }
  ];

  // Star rating component
  const StarRating = ({ rating }) => {
    return (
      <div className="star-rating">
        {[...Array(5)].map((_, index) => (
          <span key={index} className={index < rating ? 'star filled' : 'star'}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </span>
        ))}
      </div>
    );
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <span className="section-subtitl">Client Feedback</span>
          <h2 className="section-title">What Our Customers Say</h2>
          <div className="header-divider"></div>
          <p className="section-description">
            Hear from healthcare professionals and satisfied customers about their experience with our pharmacy services.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <StarRating rating={testimonial.rating} />
                <p className="testimonial-text">"{testimonial.text}"</p>
              </div>
              <div className="testimonial-author">
                <div className="avatar">{testimonial.avatar}</div>
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-role">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;